(function ($, Drupal) {
  Drupal.behaviors.VanityMenu = {
    attach: function (context, settings) {

      once('main__nav', '.main-nav', context).forEach((e)  => {
        $(e).delay(500).removeClass('d-none');
      });

      once('hamburger__collapse', '.hamburger--collapse', context).forEach((e)  => {
        $(e).on('click', () => {
          $(this).toggleClass('collapsed');
          $('.site-header').toggleClass('mobile-navi');
          $('#main-collapse').toggleClass('mobile-navi');
          $('#col-hauptnavigation').toggleClass('d-none');
          $('#col-hauptnavigation').toggleClass('mobile-navi');
          $('#header-bg-mobile').toggleClass('d-none');
          $('.site-main').toggleClass('blur');
        });
      });

      once('js__menutoggle', '.js-menutoggle', context).forEach((e)  => {

        $(e).on('click', () => {
          var el = $(this);
          var target = $($(this).data('target'));

          if (el.hasClass('toggle')) {
            target.slideUp();
          } else {
            target.slideDown();
          }
          el.toggleClass('toggle');
        });
      });

    }
  }
})(jQuery, Drupal);
